export const PATH = {
  NOTIFICATION: 'notification',
  NOTIFICATION_LIST: 'notification/list',
  NOTIFICATION_COUNT: 'notification/count',
}
